


























































































































































































































































































































































































import moment from "moment";
import { Component, Vue } from "vue-property-decorator";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { mixins } from "vue-class-component";
import Plans from "@/resources/mixins/plans/plans";
import { PLAN } from "@/resources/constants/plan";
import { i18n } from "@/resources/locales";
@Component({
  name: "robot-modal-component",
})
export default class RobotModalComponent extends mixins(
  NotificationEvent,
  Plans
) {
  //currentPage = 1;
  //lastPage = 0;
  PLAN = PLAN;
  requestNextPage = false;
  lastIdMessages = null;
  loadHistory = false;
  scrollableDiv = null;
  currentPageChats = 1;
  lastPageChats = 0;
  loadChats = false;
  scrollableDivChats = null;
  text = "";
  responseText = [];
  chats = [];
  isAiActivated = true;
  loading = false;
  idChat = null;
  idToday = null;
  idYesterday = null;
  idDays = [];
  //name = "";
  //description = "";
  //welcome = "";
  //image = null;
  //questions = [];
  //welcomeQuestions = [];
  typingBot = false;
  activeSelectAssistant = false;
  selectedAssistant = null;
  assistants = [];
  loadingCard = null;
  isLoadChat = true;
  createNewChat = true;
  myExt = () => [
    {
      type: "lang",
      regex: /markdown/g,
      replace: "showdown",
    },
  ];
  mounted() {}
  get active() {
    const e = this.$store.getters["SystemStore/getShowRobotModal"];
    if(e && !this.activeOptionPlan(PLAN.IA)) {
      this.onWarning("", i18n.t("plans.premium"));
      this.active = false
      return false;
    }
    if (e && this.activeOptionPlan(PLAN.IA)) {
      this.$store.dispatch("SidebarStore/setActiveMenuAction", -1);
      this.$store.dispatch("SystemStore/setShowCameraOptionsAction", false);
      this.$store.dispatch("SidebarStore/setOpenChatAction", false);
      if (this.assistant == null) this.getAssistants();
      else {
        if (this.currentPageChats == 1) {
          this.selectAssistant(this.assistant);
        }
      }
      /*if (this.space && this.space.bot) {
        this.name = this.space.bot.name;
        this.description = this.space.bot.description;
        this.welcome = this.space.bot.welcome;
        this.image = this.space.bot.image;
        this.welcomeQuestions = this.space.bot.questions;
      }*/
      //if (this.currentPageChats == 1) this.getChats();
      setTimeout(() => {
        this.scrollableDiv = document.getElementById("body-scroll");
        this.scrollableDiv.addEventListener("scroll", this.nextPage);
        this.scrollableDivChats = document.getElementById("body-chat-scroll");
        this.scrollableDivChats.addEventListener("scroll", this.nextPageChats);
      }, 500);
    }
    return e;
  }
  get space() {
    return this.$store.getters["SpaceStore/getSpace"];
  }
  set active(e) {
    this.$store.dispatch("SystemStore/setRobotModalAction", e);
  }
  get assistant() {
    return this.$store.getters["SystemStore/getAssistant"];
  }
  async getAssistants() {
    this.loadingCard = this.$vs.loading({
      target: this.$refs.content,
    });
    let space = this.$store.getters["SpaceStore/getSpace"];
    await this.$store.dispatch("UserStore/getAssistantsAction", {
      superSpaceId: space.superSpace.id,
      callback: async (response) => {
        this.assistants = response.data;
        if (this.assistant == null && this.chats.length < 1)
          this.activeSelectAssistant = true;
        if (this.loadingCard) this.loadingCard.close();
      },
      callbackError: (error) => {
        console.log("TTT getAssistants KO ", error);
        if (this.loadingCard) this.loadingCard.close();
      },
    });
  }
  nextPage() {
    if (
      Math.abs(this.scrollableDiv.scrollTop - this.scrollableDiv.clientHeight) +
        100 >=
      this.scrollableDiv.scrollHeight
    ) {
      if (this.loadHistory) return;
      this.loadHistory = true;
      if (this.requestNextPage) this.getChatHistory(this.idChat, false);
    }
  }
  nextPageChats() {
    if (
      Math.abs(
        this.scrollableDivChats.scrollTop + this.scrollableDivChats.clientHeight
      ) +
        50 >=
      this.scrollableDivChats.scrollHeight
    ) {
      if (this.loadChats) return;
      this.loadChats = true;
      this.currentPageChats++;
      if (this.currentPageChats <= this.lastPageChats) {
        this.getChats();
      }
    }
  }
  preventEnter(event): void {
    if (event.keyCode === 13) {
      if (!event.shiftKey) {
        event.preventDefault();
        this.setMessage();
      }
    }
  }
  async getChats() {
    this.loading = true;
    let space = this.$store.getters["SpaceStore/getSpace"];
    await this.$store.dispatch("UserStore/getAssistantChatsAction", {
      superSpaceId: space.superSpace.id,
      assistantId: this.selectedAssistant.assistantId,
      callback: (response) => {
        this.loading = false;
        if (this.currentPageChats == 1) {
          this.chats = response.data;
          if (this.chats.length > 0) {
            //this.idChat = this.chats[0].id;
            //this.getChatHistory(
            //  this.chats[0].id,
            //  false,
            //  this.selectedAssistant
            //);
          }
        } else {
          this.chats.push(...response.data);
        }
        setTimeout(() => {
          this.loadChats = false;
        }, 500);
      },
      callbackError: (error) => {
        console.log("TTT getChatsAction KO ", error);
        this.loading = false;
        this.loadChats = false;
      },
    });
  }
  /*async getChats() {
    this.loading = true;
    await this.$store.dispatch("UserStore/getChatsBotAction", {
      spaceId: this.space.id,
      page: this.currentPageChats,
      callback: (response) => {
        this.lastPageChats = parseInt(response.headers["pagination-last-page"]);
        this.loading = false;
        if (this.currentPageChats == 1) {
          this.chats = response.data;
          if (this.chats && this.chats.length > 0) {
            this.idChat = this.chats[0].id;
            this.getChatHistory(this.chats[0].id, false);
          } else {
            if (this.welcome != null && this.responseText.length === 0)
              this.responseText.push({
                message: this.welcome,
                role: "assistant",
                id: -1,
              });
          }
        } else {
          this.chats.push(...response.data);
        }
        setTimeout(() => {
          this.loadChats = false;
        }, 500);
      },
      callbackError: (error) => {
        console.log("TTT getChatsAction KO ", error);
        this.loading = false;
        this.loadChats = false;
      },
    });
  }*/
  async setMessage() {
    if (this.text.trim().length <= 0) return;
    //this.questions = [];
    this.loading = true;
    let space = this.$store.getters["SpaceStore/getSpace"];
    if (this.idChat == null) {
      await this.$store.dispatch("UserStore/createAssistantChatAction", {
        superSpaceId: space.superSpace.id,
        data: {
          assistantId: this.selectedAssistant.assistantId,
        },
        callback: async (response) => {
          this.chats.unshift({
            id: response.data.id,
            title: response.data.title,
            //createdAt: response.data.createdAt,
          });
          this.idChat = response.data.id;
          this.sendMessage(true);
        },
        callbackError: (error) => {
          console.log("TTT setMessage KO ", error);
          this.loading = false;
        },
      });
    } else this.sendMessage();
  }
  /*async setMessage() {
    if (this.text.trim().length <= 0) return;
    //this.questions = [];
    this.loading = true;
    if (this.idChat == null) {
      await this.$store.dispatch("UserStore/createChatBotAction", {
        spaceId: this.space.id,
        callback: async (response) => {
          this.chats.unshift({
            id: response.data.id,
            title: response.data.title,
            createdAt: response.data.createdAt,
          });
          this.idChat = response.data.id;
          this.sendMessage(true);
        },
        callbackError: (error) => {
          console.log("TTT setMessage KO ", error);
          this.loading = false;
        },
      });
    } else this.sendMessage();
  }*/
  async sendMessage(firtTime = false) {
    const textMessage = this.text;
    this.responseText.push({ content: this.text, role: "user" });
    this.text = "";
    let space = this.$store.getters["SpaceStore/getSpace"];
    await this.$store.dispatch("UserStore/sendAssistantMessageAction", {
      idChat: this.idChat,
      superSpaceId: space.superSpace.id,
      data: {
        message: textMessage,
      },
      callback: async (response) => {
        const reader = response.body.getReader();
        let isCreate = false;
        let itemToUpdate = null;
        // Función para leer y procesar los datos en tiempo real
        const read = async () => {
          const { done, value } = await reader.read();
          if (done) {
            setTimeout(() => {
              this.updateScroll();
            }, 1);
            this.typingBot = false;
            this.loading = false;
            if (firtTime) {
              setTimeout(async () => {
                await this.$store.dispatch(
                  "UserStore/createAssistantTitleAction",
                  {
                    idChat: this.idChat,
                    superSpaceId: space.superSpace.id,
                    callback: async (response) => {
                      let chat = this.chats.find(
                        (item) => item.id === response.data.id
                      );
                      chat.title = response.data.title;
                    },
                    callbackError: (error) => {
                      console.log("TTT createTitleChatAction KO ", error);
                    },
                  }
                );
              }, 200);
            }
            return;
          }
          let message = new TextDecoder("utf-8").decode(value);
          const lines = message.split("\n\n");
          const parsedLines = lines
            .map((line) => line.replace(/^data: /, "").trim())
            .filter((line) => line !== "" && line !== "[DONE]")
            .map((line) => {
              try {
                return JSON.parse(line);
              } catch (ex) {
                console.log("ERROR ", line);
              }
              return "";
            });

          for (const parsedLine of parsedLines) {
            if (!parsedLine) continue;
            const { content } = parsedLine;
            if (content === undefined) continue;
            if (!isCreate) {
              this.typingBot = true;
              isCreate = true;
              this.responseText.push({
                content: "",
                role: "assistant",
                id: null,
              });
              itemToUpdate = this.responseText[this.responseText.length - 1];
            }
            if (isCreate && itemToUpdate) {
              itemToUpdate.content = itemToUpdate.content + content;
            }
          }

          // Continúa leyendo los datos en tiempo real
          this.updateScroll();
          read();
        };

        read(); // Inicia la lectura de los datos
      },
      callbackError: (error) => {
        console.log("TTT sendMessage KO ", error);
      },
    });
  }
  /*async sendMessage(firtTime = false) {
    const textMessage = this.text;
    this.responseText.push({ message: this.text, role: "user" });
    this.text = "";
    await this.$store.dispatch("UserStore/sendMessageBotAction", {
      spaceId: this.space.id,
      idChat: this.idChat,
      data: {
        message: textMessage,
      },
      callback: async (response) => {
        const reader = response.body.getReader();
        let isCreate = false;
        let itemToUpdate = null;
        // Función para leer y procesar los datos en tiempo real
        const read = async () => {
          const { done, value } = await reader.read();
          if (done) {
            setTimeout(() => {
              this.updateScroll();
            }, 1);
            this.typingBot = false;
            this.loading = false;
            ///await this.$store.dispatch("HawkingsStore/getQuestionsAction", {
              idChat: this.idChat,
              roomId: this.idRoom,
              callback: async (response) => {
                this.questions = response.data;
                this.typingBot = false;
                this.loading = false;
                setTimeout(() => {
                  this.updateScroll();
                }, 1);
              },
              callbackError: (error) => {
                this.typingBot = false;
                this.loading = false;
              },
            //});
            if (firtTime) {
              setTimeout(async () => {
                await this.$store.dispatch("UserStore/createTitleChatAction", {
                  spaceId: this.space.id,
                  idChat: this.idChat,
                  callback: async (response) => {
                    let chat = this.chats.find(
                      (item) => item.id === response.data.id
                    );
                    chat.title = response.data.title;
                  },
                  callbackError: (error) => {
                    console.log("TTT createTitleChatAction KO ", error);
                  },
                });
              }, 2000);
            }
            return;
          }
          let message = new TextDecoder("utf-8").decode(value);
          const lines = message.split("\n\n");
          const parsedLines = lines
            .map((line) => line.replace(/^data: /, "").trim()) // Remove the "data: " prefix
            .filter((line) => line !== "" && line !== "[DONE]") // Remove empty lines and "[DONE]"
            .map((line) => {
              try {
                return JSON.parse(line);
              } catch (ex) {
                console.log("ERROR ", line);
              }
              return "";
            });

          for (const parsedLine of parsedLines) {
            if (!parsedLine) continue;
            const { content } = parsedLine;
            if (content === undefined) continue;
            if (!isCreate) {
              this.typingBot = true;
              isCreate = true;
              let id =
                this.responseText.length > 2
                  ? this.responseText[this.responseText.length - 2].id
                  : 0;
              id++;
              this.responseText.push({
                message: content,
                role: "assistant",
                id: id,
              });
              itemToUpdate = this.responseText.find((item) => item.id === id);
            }
            if (isCreate && itemToUpdate) {
              itemToUpdate.message = itemToUpdate.message + content;
            }
          }

          // Continúa leyendo los datos en tiempo real
          this.updateScroll();
          read();
        };

        read(); // Inicia la lectura de los datos
      },
      callbackError: (error) => {
        console.log("TTT KO ", error);
      },
    });
  }*/
  delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  async getChatHistory(idChat: number, isClear: boolean, data: any = null) {
    //if (data) this.setSelectAssistant(data);
    this.idChat = idChat;
    if (isClear) {
      this.responseText = [];
      this.requestNextPage = false;
      this.lastIdMessages = null;
    }
    let space = this.$store.getters["SpaceStore/getSpace"];
    await this.$store.dispatch("UserStore/getAssistantChatHistoryAction", {
      idChat: idChat,
      superSpaceId: space.superSpace.id,
      idMessage: this.responseText.length > 0 ? this.lastIdMessages : null,
      callback: (response) => {
        this.requestNextPage = response.data.hasMore;
        this.lastIdMessages = response.data.lastId;
        if (this.responseText.length == 0) {
          this.responseText = response.data.messages;
        } else {
          this.responseText.unshift(...response.data.messages);
        }
        setTimeout(() => {
          this.loadHistory = false;
        }, 500);
      },
      callbackError: (error) => {
        this.loadHistory = false;
        this.responseText = [];
        console.log("TTT getChatHistory KO ", error);
      },
    });
  }
  /*async getChatHistory(idChat: number, isClear: boolean) {
    this.idChat = idChat;
    if (isClear) {
      this.currentPage = 1;
      this.lastPage = 0;
    }
    await this.$store.dispatch("UserStore/getHistoryBotAction", {
      spaceId: this.space.id,
      idChat: idChat,
      page: this.currentPage,
      callback: (response) => {
        this.lastPage = parseInt(response.headers["pagination-last-page"]);
        if (this.currentPage == 1) {
          this.responseText = [];
          this.responseText = response.data;
        } else {
          this.responseText.push(...response.data);
        }
        setTimeout(() => {
          this.loadHistory = false;
        }, 500);
      },
      callbackError: (error) => {
        this.loadHistory = false;
        console.log("TTT sendMessage KO ", error);
      },
    });
  }*/
  newChat() {
    this.currentPageChats = 1;
    this.requestNextPage = false;
    this.lastIdMessages = null;
    this.responseText = [];
    this.idChat = null;
    this.chats = [];
    this.text = "";
    this.idToday = null;
    this.idYesterday = null;
    this.idDays = [];
    this.activeSelectAssistant = true;
    this.createNewChat = false;
  }
  checkSeparationChat(time: string, id: string): boolean {
    const date = moment(time);

    const today = moment().startOf("day");
    if (moment(date).isSame(today, "d")) {
      if (!this.idToday) this.idToday = id;
      return true;
    }

    const yesterday = moment().subtract(1, "days").startOf("day");
    if (moment(date).isSame(yesterday, "d")) {
      if (!this.idYesterday) this.idYesterday = id;
      return true;
    }

    const data = {
      id: id,
      date: moment(time).format("L"),
    };
    const i = this.idDays.findIndex((e) => e.date === moment(time).format("L"));
    if (i == -1) this.idDays.push(data);
    return true;
  }
  close() {
    this.active = false;
    this.currentPageChats = 1;
    this.responseText = [];
    this.chats = [];
    this.text = "";
    this.idChat = null;
    this.idToday = null;
    this.idYesterday = null;
    this.idDays = [];
    this.selectedAssistant = null;
    this.requestNextPage = false;
    this.lastIdMessages = null;
  }
  copy(message): void {
    if (message.length <= 0) return;
    const cb = navigator.clipboard;
    cb.writeText(message).then(() =>
      this.onDefault("", this.$i18n.t("hawkings.messageCopiedClipboard"))
    );
  }
  sendQuestion(message: string) {
    if (!message) return;
    this.text = message;
    this.setMessage();
  }
  updateScroll() {
    let chatContainer = document.getElementById("body-scroll");
    chatContainer.scrollTop = chatContainer.scrollHeight;
  }
  selectAssistant(data) {
    if (!this.activeOptionPlan(PLAN.IA)) return;
    if (this.createNewChat) {
      this.setSelectAssistant(data);
      this.activeSelectAssistant = false;
      if (this.isLoadChat) this.getChats();
      this.isLoadChat = true;
    } else if (!this.createNewChat) {
      this.setSelectAssistant(data);
      this.activeSelectAssistant = false;
      this.createNewChat = true;
      this.getChats();
    }
    this.clearTooltip();
  }
  closeModal() {
    this.activeSelectAssistant = false;
  }
  setSelectAssistant(data) {
    let newSelectAssistant = {
      assistantId: data.assistantId ? data.assistantId : data.id,
      name: data.name,
      description: data.assistantDescription,
    };
    this.selectedAssistant = newSelectAssistant;
  }
  clearTooltip() {
    try {
      const tooltip = document.getElementsByClassName("vs-tooltip");
      if (tooltip)
        while (tooltip.length > 0) {
          tooltip[0].parentNode.removeChild(tooltip[0]);
        }
    } catch (error) {
      console.log("TTT clearTooltip", error);
    }
  }
}
